import React, { useState } from "react";
import PropTypes from "prop-types";
import { fromJS } from "immutable";
import api from "APP_ROOT/api";
import { ADD } from "APP_ROOT/constants";
import { PORTAL_PURCHASE } from "MODULES/PurchaseOrders/constants";
import { useDispatch } from "APP_ROOT/hooks";
import * as actionTypes from "MODULES/PurchaseOrders/actionTypes";
import CreateOrderForm from "./CreateOrder";
import CreateLineItemForm from "./CreateLineItem";

export default function Create({ close, part }) {
  const { onSubmit, createdPurchaseOrder } = useCreateOnSubmit();

  if (createdPurchaseOrder) {
    return (
      <CreateLineItemForm
        close={close}
        part={part}
        purchaseOrder={fromJS(createdPurchaseOrder)}
      />
    );
  }
  return <CreateOrderForm part={part} close={close} onSubmit={onSubmit} />;
}

Create.propTypes = {
  close: PropTypes.func.isRequired,
  part: PropTypes.shape({})
};

// Custom hooks
function useCreateOnSubmit() {
  const [createdPurchaseOrder, setCreatedPurchaseOrder] = useState(null);

  const onSubmit = formData => {
    modifyFormDataForContact(formData);

    return api.purchaseOrders.create(formData).then(resp => {
      const dispatch = useDispatch();
      setCreatedPurchaseOrder(resp.data);
      dispatch({
        type: actionTypes.SET,
        purchaseOrder: resp.data
      });
    });
  };

  return {
    onSubmit,
    createdPurchaseOrder
  };
}

export function modifyFormDataForContact(formData) {
  if (formData.contact_id === ADD) {
    formData.contact_id = null;
    formData.portal_purchase = false;
  }

  if (formData.contact_id === PORTAL_PURCHASE) {
    formData.contact_id = null;
    formData.portal_purchase = true;
  }

  if (formData.contact_id) {
    formData.portal_purchase = false;
  }
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/PurchaseOrders/Create/Create.jsx